import {css} from '@mui/material';
import {GetStylesFunction, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import {Link} from 'react-router-dom';
import {baseEntityLinkParams} from 'src/js/lib/raw_rendering/base_entity_link_params';

import styles from './EntityLink.less';
import {EntityLinkProps} from '../file_types';

type Props = EntityLinkProps;
const EntityLinkComponent: React.FC<Props> = (props) => {
  const {
    children,
    suppressPadding = false,
    titleText = '',
    hrefTo,
    isAllowed,
    onClick,
    inputCss,
    replaceRoute,
    textAlign,
    route: _route,
    id: _id,
    searchParams: _searchParams,
    overflowStyles,
    notClickable,
    ...extraProps
  } = baseEntityLinkParams(props, {}, utils.componentUtils.getDisplayName(EntityLinkComponent));

  const muiStyles = getStyles({params: {suppressPadding, inputCss, textAlign, overflowStyles, notClickable}});

  return (
    <span
      {...extraProps}
      css={muiStyles.wrapper}
      className={classNames({
        [styles.dlEntityLinkLayout]: !suppressPadding,
      })}
    >
      {isAllowed ? (
        <Link // eslint-disable-line jsx-a11y/anchor-is-valid
          title={String(titleText)}
          tabIndex={0}
          to={notClickable ? '#' : hrefTo}
          onClick={
            notClickable
              ? (event) => {
                  event.preventDefault();
                  (document.activeElement as HTMLElement | undefined)?.blur();
                }
              : onClick
          }
          replace={replaceRoute}
        >
          {children}
        </Link>
      ) : (
        children
      )}
    </span>
  );
};

EntityLinkComponent.displayName = 'EntityLink';

export const EntityLink = EntityLinkComponent;

const getStyles: GetStylesFunction = (options) => {
  const overflowStyles: any = options?.params?.overflowStyles
    ? {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }
    : {};
  const notClickable = options?.params?.notClickable;
  return {
    wrapper: css(
      {
        display: 'inline-block',
        maxWidth: '100%',
        color: 'var(--dlHighlightedColor)',
        textAlign: options?.params?.textAlign ?? 'right',
        ...overflowStyles,
        a: {
          'display': 'inline-block',
          'maxWidth': '100%',
          'color': 'var(--dlHighlightedColor)',
          'cursor': notClickable ? 'default' : 'pointer',
          ...overflowStyles,

          '&:hover, &:focus': {
            outline: 'none',
            color: notClickable ? undefined : 'var(--dlHighlightedFocusColor)',
          },

          '&:active': {
            outline: 'none',
            color: notClickable ? undefined : 'var(--dlHighlightedActiveColor)',
          },
        },
      },
      options?.params?.inputCss
    ),
  };
};
